import React, { useState, useEffect } from "react";
import { apiRequest } from "../../utils/api";

const DynamicImageEdit = () => {
  const [image, setImage] = useState(null);
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("active");

  // ✅ Fetch existing data
  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await apiRequest.get(`/dynamic-image/single/1`);
        console.log(res);
        if (res.data.status == 200) {
          setPreview(res.data.message?.url);
          setStatus(res.data.message?.status);
        }
      } catch (err) {
        console.error("Fetch error:", err);
      }
    };

    fetchData();
  }, []);

  // ✅ Handle image choose
  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setImage(file);
      setPreview(URL.createObjectURL(file)); // instant preview
    }
  };

  // ✅ Handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Case 1: nothing selected
    if (!image && !status) {
      alert("⚠️ Please choose an image or status first!");
      return;
    }

    try {
      setLoading(true);

      // Case 2: only status → call update-status API
      if (!image && status) {
        const res = await apiRequest.put("/dynamic-image/update-status", {
          status,
          id: 1,
        });

        if (res.data.status === 200) {
          alert("✅ Status updated successfully!");
        } else {
          alert(res.data.message || "Failed to update status");
        }
      }
      // Case 3: both image & status → call main upload API
      else {
        const formData = new FormData();
        formData.append("image", image);
        formData.append("status", status);

        const res = await apiRequest.post("/dynamic-image/update", formData);

        if (res.data.status === 200) {
          alert("✅ Image updated successfully!");
        } else {
          alert(res.data.message || "Failed to update image");
        }
      }
    } catch (err) {
      console.error(err);
      alert("❌ Update failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container mt-4">
      <h3 style={{ textTransform: "capitalize" }}>Edit Image</h3>

      <form
        onSubmit={handleSubmit}
        className="p-3 border rounded shadow-sm bg-light"
      >
        {/* Image Upload */}
        <div className="mb-3">
          <label className="form-label">Choose Image</label>
          <input
            type="file"
            className="form-control"
            accept="image/*"
            onChange={handleImageChange}
          />
        </div>

        {/* Status */}
        <div className="mb-3">
          <label className="form-label">Status</label>
          <select
            className="form-select"
            value={status}
            onChange={(e) => setStatus(e.target.value)}
          >
            <option value="active">Active</option>
            <option value="inactive">Inactive</option>
          </select>
        </div>

        {/* Preview */}
        {preview && (
          <div className="mb-3">
            <h5>Preview</h5>
            <img
              crossOrigin="anonymous"
              src={preview}
              alt="Preview"
              className="img-fluid border rounded"
              style={{ maxHeight: "300px", objectFit: "contain" }}
            />
          </div>
        )}

        <button
          type="submit"
          className="btn btn-primary mt-3"
          disabled={loading}
        >
          {loading ? "Uploading..." : "Save Image"}
        </button>
      </form>
    </div>
  );
};

export default DynamicImageEdit;
